import { intersectionBy } from "lodash";
import { ClaimUser } from "./authorize.model";
import { dateString } from "./base.model";

export type PeriodType = "daily" | "monthly" | "yearly";

export type Period = {
  type: PeriodType;
  range: string[];
};

export interface FilterModel {
  hierarchyFilter?: string;
  period?: Period;
  [key: string]: any;
}

export interface ReportQueryParam {
  id: string;
  period?: Period;
  groupBy?: string;
  keysNeeded?: string[];
  showInHierarchy?: boolean;
  storeLabelTypes?: string[];
  [key: string]: any;
}

export interface CompareStore {
  district: string;
  satisfaction: number;
  lastMonth: number;
}

export type ReviewReport = {
  id: string;
  date: string;
  company_id: string;
  uid: string;
  customerName?: string;
  customerDevice?: string;
  answeredAt: dateString;
} & { [key: string]: any };

export interface ReportDataModel {
  main: ReportModel;
  dates: ReportModel[];
  ranges: string[];
}

export type ReportModel = {
  id: string;
  sk: dateString;
  company_id: string;
  survey_count?: number;
  groupLabel?: string;
} & {
  [key: string]: number | undefined;
};

export const getOptions = (
  loggedUser?: ClaimUser
): { label: string; value: string }[] => {
  const options = [{ value: `${loggedUser?.companyId}`, label: "Company" }]
    .concat(
      (loggedUser?.company?.region.split(",") || []).map((a) => ({
        value: `${loggedUser?.companyId}_${a}`,
        label: a,
      }))
    )
    .concat(
      (loggedUser?.company?.area.split(",") || []).map((a) => ({
        value: `${loggedUser?.companyId}_${a}`,
        label: a,
      }))
    )
    .concat(
      (loggedUser?.company?.stores || []).map((a) => ({
        value: a.id,
        label: a.name,
      }))
    );
  if (
    (loggedUser?.allowedHierarchies?.indexOf(loggedUser?.companyId) as any) >= 0
  ) {
    return options;
  }
  return intersectionBy(
    options,
    loggedUser?.allowedHierarchies?.map((a) => ({ value: a, label: a })) || [],
    "value"
  );
};

export const getFilterOptions = (
  loggedUser?: ClaimUser
): {
  label: string;
  name: string;
  options: { label: string; value: string }[];
}[] => {
  return loggedUser?.company?.filters || [];
};

export interface ReviewsContext {
  data: ReviewReport[];
  offset?: string;
  total: number;
}
